import { isNodeDebug } from "../../helpers/nodeEnvironment";

export const isSentryEnabled = (): boolean => !isNodeDebug();

/**
 * The release an event belongs to. Sentry needs it to tell "this error came back in a
 * newer build" from "an old build is still out there", which is what makes
 * "Resolve in the next release" work. Undefined when unset - Sentry then omits it
 * rather than filing every event under a bogus version.
 */
export const getSentryRelease = (): string | undefined => import.meta.env.REACT_APP_VERSION;

/**
 * Environments derived from the host when the build was not told one. Only hosts whose
 * meaning is certain are mapped - guessing a name for production would file its events
 * under a label nobody configured.
 */
const HOST_ENVIRONMENTS: Array<[test: (hostname: string) => boolean, environment: string]> = [
  [(hostname) => hostname === "localhost" || hostname === "127.0.0.1", "local"],
  [(hostname) => hostname.endsWith("ss-stage.com"), "staging"],
];

export const getSentryEnvironment = (hostname: string = window.location.hostname): string => {
  if (isNodeDebug()) {
    return "debug";
  }

  if (import.meta.env.REACT_APP_SENTRY_ENVIRONMENT) {
    return import.meta.env.REACT_APP_SENTRY_ENVIRONMENT;
  }

  const fromHost = HOST_ENVIRONMENTS.find(([test]) => test(hostname));

  return fromHost ? fromHost[1] : "unknown";
};
